import "core-js/stable";
import "regenerator-runtime/runtime";
import React, { Fragment } from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "styled-components";
import theme from "../utils/theme";
import GlobalStyles from "../styled/globals/launchpad";
import PageGlobalStyles from "../components/Homebeat/styled/page-global-styles";
import HomebeatMarketingPage from "../components/Homebeat/HomebeatMarketingPage";

document.addEventListener("DOMContentLoaded", () => {
  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <Fragment>
        <HomebeatMarketingPage />
        <GlobalStyles />
        <PageGlobalStyles />
      </Fragment>
    </ThemeProvider>,
    document.getElementById("homebeat-marketing-root")
  );
});
